package com.dwarshb.bms

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.AirplaneTicket
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.automirrored.filled.ArrowRight
import androidx.compose.material.icons.filled.BookOnline
import androidx.compose.material.icons.filled.DirectionsBus
import androidx.compose.material.icons.filled.EventSeat
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Share
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import busmanagementsystem.composeapp.generated.resources.Res
import busmanagementsystem.composeapp.generated.resources.create_trip
import busmanagementsystem.composeapp.generated.resources.create_trip_description
import busmanagementsystem.composeapp.generated.resources.enter_invitation_code
import busmanagementsystem.composeapp.generated.resources.get_ticket
import busmanagementsystem.composeapp.generated.resources.get_ticket_description
import busmanagementsystem.composeapp.generated.resources.headline
import busmanagementsystem.composeapp.generated.resources.home_page_title
import busmanagementsystem.composeapp.generated.resources.logo
import busmanagementsystem.composeapp.generated.resources.no_trips_description
import busmanagementsystem.composeapp.generated.resources.reserve_seat
import busmanagementsystem.composeapp.generated.resources.reserve_seat_description
import busmanagementsystem.composeapp.generated.resources.share_code
import busmanagementsystem.composeapp.generated.resources.share_code_description
import busmanagementsystem.composeapp.generated.resources.sign_up
import busmanagementsystem.composeapp.generated.resources.sign_up_description
import busmanagementsystem.composeapp.generated.resources.subheadline
import busmanagementsystem.composeapp.generated.resources.your_trips
import com.dwarshb.firebase.Firebase
import com.mohamedrejeb.calf.ui.sheet.AdaptiveBottomSheet
import com.mohamedrejeb.calf.ui.sheet.rememberAdaptiveSheetState
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun HomeScreen(tripViewModel: TripViewModel = TripViewModel(),
               createTrip : () -> Unit,
               joinTrip: (String)-> Unit,
               onLanguageChange: (String) -> Unit,
               onSignInClick: () -> Unit,
               onGetTicketDetails: () -> Unit,
               navigateToTripReservation: (Trip) -> Unit = {} ) {
    var invitationCode by remember { mutableStateOf("") }
    Box {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(16.dp), horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Image(
                    painter = painterResource(Res.drawable.logo), "logo",
                    modifier = Modifier.width(150.dp).height(50.dp)
                )

                Button(
                    onClick = { joinTrip(invitationCode) },
                    colors = ButtonDefaults.buttonColors(containerColor = ThemeColor.pink)
                ) {
                    Text(stringResource(Res.string.reserve_seat), color = Color.White)
                }
            }
            Spacer(modifier = Modifier.height(24.dp))
            Column(
                modifier = Modifier
                    .background(
                        Brush.verticalGradient(
                            listOf(
                                Color(0xFF6A11CB),
                                Color(0xFF2575FC)
                            )
                        )
                    )
            ) {
                Spacer(modifier = Modifier.height(50.dp))
                Text(
                    stringResource(Res.string.headline),
                    modifier = Modifier.padding(16.dp).align(Alignment.CenterHorizontally),
                    color = Color.White,
                    style = MaterialTheme.typography.displaySmall,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center
                )
                Text(
                    stringResource(Res.string.subheadline),
                    color = Color.White,
                    modifier = Modifier.padding(24.dp).align(Alignment.CenterHorizontally),
                    style = MaterialTheme.typography.bodyLarge,
                    textAlign = TextAlign.Center
                )
                Spacer(modifier = Modifier.height(16.dp))
                Button(
                    onClick = {
                        createTrip()
                    }, modifier = Modifier.fillMaxWidth(0.5f)
                        .align(Alignment.CenterHorizontally).padding(16.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color.White,
                        contentColor = MaterialTheme.colorScheme.primary
                    )
                ) {
                    Text(stringResource(Res.string.create_trip))
                }
                Spacer(modifier = Modifier.height(8.dp))
                OutlinedTextField(
                    value = invitationCode,
                    onValueChange = {
                        invitationCode = it
                    },
                    placeholder = { Text(stringResource(Res.string.enter_invitation_code), color = Color.White) },
                    modifier = Modifier.fillMaxWidth()
                        .padding(16.dp)
                        .background(Color.White.copy(0.1f)),
                    trailingIcon = {
                        IconButton(onClick = {
                            joinTrip(invitationCode)
                        }) {
                            Icon(Icons.AutoMirrored.Default.ArrowRight, tint = Color.White, contentDescription = "")
                        }
                    }
                )
                Spacer(modifier = Modifier.height(50.dp))
            }
            Spacer(modifier = Modifier.height(16.dp))
            Text(
                stringResource(Res.string.home_page_title),
                fontSize = 20.sp,
                fontWeight = FontWeight.Bold,
                color = Color.Black
            )
            Spacer(modifier = Modifier.height(8.dp))
            FlowRow {
                InfoCard(
                    icon = Icons.Default.DirectionsBus,
                    title = stringResource(Res.string.create_trip),
                    description = stringResource(Res.string.create_trip_description)
                )
                InfoCard(
                    icon = Icons.Default.Share,
                    title = stringResource(Res.string.share_code),
                    description = stringResource(Res.string.share_code_description)
                )
                InfoCard(
                    icon = Icons.Default.EventSeat,
                    title = stringResource(Res.string.reserve_seat),
                    description = stringResource(Res.string.reserve_seat_description)
                )
                InfoCard(
                    icon = Icons.Default.BookOnline,
                    title = stringResource(Res.string.get_ticket),
                    description = stringResource(Res.string.get_ticket_description)
                )
            }
            Spacer(modifier = Modifier.height(16.dp))
            Text(
                "\u00A9 2025 Darshan Bhanushali. All rights reserved.",
                color = Color.Gray,
                fontSize = 12.sp
            )
        }
        var showBottomSheet by remember { mutableStateOf(false) }

        Column(modifier = Modifier.align(Alignment.BottomEnd)) {
            FloatingActionButton(
                onClick = {
                    onGetTicketDetails()
                },
                shape = CircleShape,
                containerColor = Color(0xFFD81B60),
                modifier = Modifier.padding(12.dp)
            ) {
                Icon(Icons.AutoMirrored.Default.AirplaneTicket, "", tint = Color.White)
            }

            FloatingActionButton(
                onClick = {
                    showBottomSheet = true
                },
                shape = CircleShape,
                containerColor = Color(0xFFD81B60),
                modifier = Modifier.padding(12.dp)
            ) {
                Icon(Icons.Default.Person, "", tint = Color.White)
            }
        }
        if(showBottomSheet) {
            BottomSheetDashboard(tripViewModel,
                navigateToTripReservation = {
                    showBottomSheet = false
                    navigateToTripReservation(it) },
                onLanguageChange = {onLanguageChange(it)},
                onSignIn = {
                    showBottomSheet = false
                    if (it) {
                        onSignInClick()
                    }
                }
            )
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun BottomSheetDashboard(tripViewModel: TripViewModel,
                         navigateToTripReservation: (Trip) -> Unit,
                         onSignIn: (Boolean) -> Unit,
                         onLanguageChange: (String) -> Unit) {
    val state = rememberAdaptiveSheetState()

    AdaptiveBottomSheet(onDismissRequest = {
        onSignIn(false)
    },
        adaptiveSheetState = state) {
        Column(modifier = Modifier.padding(16.dp)) {
            var language by remember { mutableStateOf("English") }
            if (!getPlatform().name.lowercase().contains("web")) {
                CustomDropdownMenu(
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                        .padding(8.dp),
                    items = listOf("English", "Gujarati", "Hindi"),
                    label = "Language",
                    selected = language,
                    onSelected = {
                        onLanguageChange(it)
                        language = it
                    }
                )
            }
            val currentUser = Firebase.getCurrentUser()
            if (currentUser==null) {
                Text(
                    stringResource(Res.string.sign_up_description),
                    textAlign = TextAlign.Center,
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                )
                Spacer(modifier = Modifier.height(16.dp))
                Button(
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFD81B60)),
                    modifier = Modifier.fillMaxWidth(), onClick = {
                        onSignIn(true)
                    }) {
                    Text(stringResource(Res.string.sign_up))
                }
            } else {
                val trips = remember { mutableStateMapOf<String,Trip>() }
                tripViewModel.getAppUserTrips {
                    if (it != null) {
                        trips[it.id] = it
                    }
                }
                if (trips.isNotEmpty()) {
                    Text(
                        stringResource(Res.string.your_trips),
                        modifier = Modifier.fillMaxWidth().padding(16.dp),
                        style = MaterialTheme.typography.titleMedium,
                        textAlign = TextAlign.Center)
                    trips.values.forEach {
                        val trip = it
                        Row(Modifier.fillMaxWidth()
                                .clickable {
                                    navigateToTripReservation(it)
                                },
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Column {
                                Text(
                                    trip.departureLocation,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 24.sp
                                )
                                Text(trip.departureDate, fontSize = 12.sp)
                            }
                            Icon(
                                Icons.AutoMirrored.Default.ArrowForward,
                                contentDescription = null
                            )
                            Column(horizontalAlignment = Alignment.End) {
                                Text(
                                    trip.arrivalLocation,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 24.sp
                                )
                                Text(trip.arrivalDate, fontSize = 12.sp)
                            }
                        }
                        HorizontalDivider(thickness = 0.5.dp)
                    }
                } else {
                    Text(stringResource(Res.string.no_trips_description))
                }

            }
        }
    }
}

@Composable
fun InfoCard(icon: ImageVector, title: String, description: String) {
    Card(
        modifier = Modifier
            .width(300.dp)
            .padding(8.dp),
        elevation = CardDefaults.cardElevation(4.dp)
    ) {
        Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(
                icon,
                contentDescription = null,
                tint = Color(0xFF6A11CB),
                modifier = Modifier.size(40.dp)
            )
            Spacer(modifier = Modifier.width(16.dp))
            Column {
                Text(title, fontWeight = FontWeight.Bold, fontSize = 18.sp)
                Text(description, fontSize = 14.sp, color = Color.Gray)
            }
        }
    }
}